export const const_routes = {

    SCHEMA:'api',
    VERSIONV1 : 'v1',
    VERSIONV2 : 'v2',
    
    
    ROUTE_AUTH:'auth',
    ROUTE_USERS:'users',
    ROUTE_USER_PREFERENCES:'user-preferences',
    ROUTE_USER_ROLE:'user-role',
    ROUTE_NOTIFY:'notify',
    ROUTE_FORMATS:'formats',
    ROUTE_FILE:'file',
    ROUTE_USER_FILE:'user-file',
    ROUTE_INFORMATION_FILE:'information-file',

    ROUTE_CLIENT:'client',
    ROUTE_CATALOGROLE:'catalog-role',
    ROUTE_CATALOGCIIU:'catalog-ciiu',
    ROUTE_CATALOGCIIU_INFO:'catalog-ciiu-info',
    ROUTE_LOCATION:'location',
    ROUTE_LOCATION_INFO:'location-info',
    ROUTE_CIIUSERIE:'ciiuserie',
    ROUTE_TRACKING_HISTORY:'tracking',
    ROUTE_CATALOGTYPE:'catalog-type',
    ROUTE_CATALOG:'catalog',
    ROUTE_CATALOG_COUNTRY:'catalog-country',
    ROUTE_SUPPLIER:'supplier',
    ROUTE_CONTACTINFO:'contact-info',
    ROUTE_OPTIMIZATION:'optimization',
    

    ROUTE_SEARCH_INFO:'search-info',
    ROUTE_SEARCH_RESULT:'search-result',
    ROUTE_COMPARE_RESULT:'compare-result',

    
    ROUTE_TECHNOLOGY:'technology',
    ROUTE_ALTERNATIVE:'alternative',
    ROUTE_EXPERIENCE:'experience',
    ROUTE_INNOVATION:'innovation',
    ROUTE_ASSISTANCE:'assistance',
    ROUTE_FINANCIAL:'financial',
    ROUTE_VISION:'vision',
    ROUTE_REGULATION:'regulation',

    ROUTE_ADAPTATION_MEASURE:'adaptation-measure',
    ROUTE_ADAPTATION_STRATEGY:'adaptation-strategy',
    ROUTE_ALTERNATIVE_TECHNOLOGY:'alternative-technology',
    ROUTE_TECHNICAL_INNOVATION:'technical-innovation',
    ROUTE_CONCEPTUAL_VISION:'conceptual-vision',
    ROUTE_INTERNATIONAL_REGULATION:'international-regulation',
    ROUTE_FINANCIAL_ASSISTANCE:'financial-assistance',
    ROUTE_TECHNICAL_ASSISTANCE:'technical-assistance',
    ROUTE_ADAPTATION_MEASURE_FILE:'adaptation-measure-file',
    ROUTE_ADAPTATION_STRATEGY_FILE:'adaptation-strategy-file',
    ROUTE_ALTERNATIVE_TECHNOLOGY_FILE:'alternative-technology-file',
    ROUTE_TECHNICAL_INNOVATION_FILE:'technical-innovation-file',
    ROUTE_TECHNOLOGY_FILE:'technology-file',
    
    ROUTE_TECHNOLOGY_FILE_DATA:'technology-file-data',
    ROUTE_ALTERNATIVE_FILE_DATA:'alternative-file-data',
    ROUTE_EXPERIENCE_FILE_DATA:'experience-file-data',
    ROUTE_INNOVATION_FILE_DATA:'innovation-file-data',
    ROUTE_ASSISTANCE_FILE_DATA:'assistance-file-data',
    ROUTE_FINANCIAL_FILE_DATA:'financial-file-data',
    ROUTE_REGULATION_FILE_DATA:'regulation-file-data',
    ROUTE_VISION_FILE_DATA:'vision-file-data',

    
    ROUTE_INFORMATION_ADAPTATION_MEASURE:'information-adaptation-measure',
    ROUTE_INFORMATION_ADAPTATION_STRATEGY:'information-adaptation-strategy',
    ROUTE_INFORMATION_ALTERNATIVE_TECHNOLOGY:'information-alternative-technology',
    ROUTE_INFORMATION_TECHNICAL_INNOVATION:'information-technical-innovation',
    ROUTE_INFORMATION_CONCEPTUAL_VISION:'information-conceptual-vision',
    ROUTE_INFORMATION_FINANCIAL_ASSISTANCE:'information-financial-assistance',
    ROUTE_INFORMATION_TECHNICAL_ASSISTANCE:'information-technical-assistance',
    ROUTE_INFORMATION_TECHNOLOGY:'information-technology',

    ROUTE_NATURAL_PHENOMENON:'natural-phenomenon',
    ROUTE_SEARCH_INFO:'search-info',
    ROUTE_SOURCE_INFORMATION:'source-information',

    ROUTE_NATURAL_PHENOMENON_TECHNOLOGY:'natural-phenomenon-technology',
    ROUTE_NATURAL_PHENOMENON_ALTERNATIVE_TECHNOLOGY:'natural-phenomenon-alternative-technology',
    ROUTE_NATURAL_PHENOMENON_TECHNICAL_INNOVATION:'natural-phenomenon-technical-innovation',
    ROUTE_NATURAL_PHENOMENON_ADAPTATION_STRATEGY:'natural-phenomenon-adaptation-strategy',
    ROUTE_NATURAL_PHENOMENON_ADAPTATION_MEASURE:'natural-phenomenon-adaptation-measure',

    ROUTE_CONTINENT:'continent',
    ROUTE_REGION:'region',
    ROUTE_COUNTRY:'country',

    ROUTE_SUBJECT:'subject',
    ROUTE_TOPIC:'topic',

    ROUTE_MODULE_CONFIG:'module-config',
    ROUTE_MODULE_CONFIGURATION:'module-config',
    ROUTE_RECORD_EXCEL_UPDATE:'record-excel-update',
    ROUTE_FLOW:'flow',
    ROUTE_ROLE_FLOW:'role-flow',
    ROUTE_RULE_FLOW:'rule-flow',
    ROUTE_FLOW_HISTORY:'flow-history',
    ROUTE_FLOW_ROLE_CIIU_ASSIGNMENT:'flowRoleCiiuAssignment',
    ROUTE_FLOW_MANAGER_CONFIG:'flowManagerConfig',
    ROUTE_FLOW_MODULE_CONFIG:'flowModuleConfig',
    ROUTE_FLOW_REASSIGNMENT:'flowReassignment',
    ROUTE_FLOW_VALIDATOR_CONFIG:'flowValidatorConfig',
    ROUTE_FLOW_EDITOR_CONFIG:'flowEditorConfig',
    ROUTE_FLOW_CHECKLIST:'flowChecklist',
    ROUTE_FLOW_ASSIGNMENT_POLICY:'flowAssignmentPolicy',
    ROUTE_FLOW_COVERAGE:'flowCoverage',
    ROUTE_FLOW_CMI:'flowCmi',
    ROUTE_SPECIALIST_SELECTION:'specialist',
    ROUTE_SEARCH_KEY_TERM:'search-key-term',
    ROUTE_CATALOG_TOPIC:'catalog-topic',
    ROUTE_CATALOG_QUESTION:'catalog-question',

    ROUTE_MENU:'menu',

    ROUTE_CATALOGINSTITUTION:'catalog-institution',

    ROUTE_CATALOGSECTION:'catalog-section',
    ROUTE_CATALOGPHASE:'catalog-phase',

    ROUTE_CATALOGMODULE:'catalog-module',

    ROUTE_CONFIGURATION:'configuration',

    ROUTE_USER_ROLE_MODULE:'user-role-module',

    ROUTE_STATISTIC:'statistic',

    ROUTE_GROUP_CONCERN:'group-concern',

    ROUTE_SUGGEST_CASE:'suggest-case',
    ROUTE_DOCUMENTATION:'documentation',
    ROUTE_SEMANTIC:'semantic',
    ROUTE_USER_INTEREST:'user-interest',
    ROUTE_SUPPORT_FORM:'support-form',
    ROUTE_HOME_CONTENT:'home-content',
    ROUTE_SPECIALIST_GUIDES:'specialist-guides',


}



